export default __webpack_public_path__ + "static/media/con_MOVG05.2be290af.jpg";